import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import Icon from './Icon.svelte';

export default function RefreshCw($$anchor, $$props) {
	const iconNode = [
		[
			"path",
			{ "d": "M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8" }
		],

		["path", { "d": "M21 3v5h-5" }],

		[
			"path",
			{ "d": "M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16" }
		],

		["path", { "d": "M8 16H3v5" }]
	];

	let rest = $.rest_props($$props, ['$$slots', '$$events', '$$legacy']);

	Icon($$anchor, $.spread_props(
		{
			get iconNode() {
				return iconNode;
			}
		},
		() => rest
	));
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiUmVmcmVzaEN3LnN2ZWx0ZSJdLCJzb3VyY2VzQ29udGVudCI6WyI8c2NyaXB0IGxhbmc9XCJ0c1wiPlxuICBpbXBvcnQgSWNvbiBmcm9tICcuL0ljb24uc3ZlbHRlJztcbiAgY29uc3QgaWNvbk5vZGU6IFtzdHJpbmcsIFJlY29yZDxzdHJpbmcsIHN0cmluZz5dW10gPSBbW1wicGF0aFwiLCB7IFwiZFwiOiBcIk0zIDEyYTkgOSAwIDAgMSA5LTkgOS43NSA5Ljc1IDAgMCAxIDYuNzQgMi43NEwyMSA4XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNMjEgM3Y1aC01XCIgfV0sIFtcInBhdGhcIiwgeyBcImRcIjogXCJNMjEgMTJhOSA5IDAgMCAxLTkgOSA5Ljc1IDkuNzUgMCAwIDEtNi43NC0yLjc0TDMgMTZcIiB9XSwgW1wicGF0aFwiLCB7IFwiZFwiOiBcIk04IDE2SDN2NVwiIH1dXTtcbiAgbGV0IHJlc3QgPSAkcHJvcHMoKTtcbjwvc2NyaXB0PlxuPEljb24ge2ljb25Ob2RlfSB7Li4ucmVzdH0gLz5cbiJdLCJtYXBwaW5ncyI6Ijs7T0FDUyxJQUFJLE1BQU0sZUFBZTs7cURBRGxDLENBQUM7T0FFTyxRQUE0Qzs7R0FBSyxNQUFNO0tBQUksR0FBRyxFQUFFLG9EQUFvRDs7O0dBQU0sTUFBTSxJQUFJLEdBQUcsRUFBRSxZQUFZOzs7R0FBTSxNQUFNO0tBQUksR0FBRyxFQUFFLHFEQUFxRDs7O0dBQU0sTUFBTSxJQUFJLEdBQUcsRUFBRSxXQUFXOzs7S0FDalEsSUFBSTs7Ozs7Ozs7UUFFVyxJQUFJOztBQUQxQixDQUFDIn0=